import { AxiosError } from 'axios';
import { useGet } from 'hooks/use-get';
import React, { useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { getScenarioPlan } from 'views/playground/features/scenario-planner-2.0/api/get-scenario-plan';
import { ScenarioPlan } from 'views/playground/features/scenario-planner-2.0/types/scenario-plan.type';

type State = {
  scenarioPlanQuery: UseQueryResult<ScenarioPlan, AxiosError<unknown, any>>;
};

const ScenarioPlanContext = React.createContext<State | undefined>(undefined);

type ScenarioPlanProviderProps = {
  children: React.ReactNode;
};

const ScenarioPlanProvider: React.FC<ScenarioPlanProviderProps> = ({ children }) => {
  const scenarioPlanQuery = useGet(['getPlaygroundScenarioPlan'], ({ queryKey }) => getScenarioPlan());

  return <ScenarioPlanContext.Provider value={{ scenarioPlanQuery }}>{children}</ScenarioPlanContext.Provider>;
};

function useScenarioPlanState() {
  const context = useContext(ScenarioPlanContext);
  if (context === undefined) {
    throw new Error('useScenarioPlanState must be used within a ScenarioPlanProvider');
  }
  return context;
}

export { ScenarioPlanProvider, useScenarioPlanState };
